/**
 * Centralized payment method configuration.
 *
 * Keeping this in one place ensures the Checkout, Admin, Dashboard,
 * AppDetail and Home pages all display identical, up-to-date bank info.
 */

export const PAYMENT_METHODS = {
  kbz_bank: {
    key: "kbz_bank",
    label: "KBZ Bank",
    shortLabel: "KBZ",
    bank: "KBZ Bank",
    branch: "TGKN Branch",
    account_name: "Daw Nwe Nwe Win",
    account_number: "027-301-00701225401",
    type: "bank_transfer",
    typeLabel: "ဘဏ်လွှဲ",
    color: "#1B75BB", // KBZ blue
  },
  cb_bank: {
    key: "cb_bank",
    label: "CB Bank",
    shortLabel: "CB",
    bank: "CB Bank",
    branch: "South-Okkalapa 16Kwae Branch",
    account_name: "Daw Nwe Nwe Win",
    account_number: "0111600100004723",
    type: "bank_transfer",
    typeLabel: "ဘဏ်လွှဲ",
    color: "#003D7A", // CB Bank blue
  },
};

/** Ordered list of available payment method keys. */
export const PAYMENT_METHOD_KEYS = Object.keys(PAYMENT_METHODS);

/** Default selected payment method on the checkout screen. */
export const DEFAULT_PAYMENT_METHOD = "kbz_bank";

/**
 * Human-readable label for a stored payment method value.
 * Handles legacy "kpay" values from older orders.
 */
export function getPaymentMethodLabel(method) {
  if (method === "admin_gift") return "Admin Gift";
  if (method === "kpay") return "KPay";
  return PAYMENT_METHODS[method]?.label || method;
}

/** Get the full payment method config, with a safe fallback. */
export function getPaymentMethod(method) {
  if (method && PAYMENT_METHODS[method]) return PAYMENT_METHODS[method];
  // Legacy / unknown methods: return a minimal stub so UI doesn't crash.
  return { key: method, label: getPaymentMethodLabel(method), typeLabel: "" };
}

export const PAYMENT_INSTRUCTIONS =
  "ပေးချေရမည့် ပမာဏနှင့် တူညီစွာ လွှဲပြီး၊ ငွေလွှဲ screenshot တစ်ခု ရိုက်ယူ၍ checkout တွင် တင်ပါ။ Admin မှ ၂၄ နာရီအတွင်း စစ်ဆေးပေးပါမည်။";
